// extracted by mini-css-extract-plugin
export default {"quickMenu":"QuickMenu_quickMenu__3pQIu"};